import { FC } from "react";
import * as format from '@format';
import { DEFAULT_CURRENCY } from '@typings/common';
import classNames from "classnames";

import s from "../InvoicePreview.module.scss";

const PaymentProgress: FC<{
  amountToBeRefunded?: number;
  amountPaid: number;
  amountDue: number;
  amountTotal: number;
  amountPending: number;
  currency: string;
  noBorder?: boolean;
}> = ({
  amountDue,
  amountPaid,
  amountTotal,
  amountPending,
  currency,
  noBorder,
  amountToBeRefunded,
}) => (
  <div className={classNames(s.headerProgress, noBorder && s.headerProgressNoBorder)}>
    <div className={s.headerProgressTop}>
      <div className={s.headerProgressPaid}>
        <p className="caption">Paid</p>
        <p className="body-lg-bold">{format.price.withCurrency(amountPaid, currency || DEFAULT_CURRENCY)}</p>
      </div>
      <div className={s.headerProgressRemaining}>
        <p className="caption">Remaining</p>
        <p className="body-lg-bold">{format.price.withCurrency(amountDue, currency || DEFAULT_CURRENCY)}</p>
      </div>
      {amountToBeRefunded && amountToBeRefunded > 0
        ? <div className={s.headerProgressRemaining}>
          <p className="caption">Amount to be refunded</p>
          <p className="body-lg-bold">{format.price.withCurrency(amountToBeRefunded, currency || DEFAULT_CURRENCY)}</p>
        </div>
        : <></>
      }
    </div>
    <div className={s.headerProgressBottom}>
      <progress value={amountPaid + amountPending} max={amountTotal} className={s.headerProgressWithPending} />
      <progress value={amountPaid} max={amountTotal} className={s.headerProgressWithPaid} />
    </div>
  </div>
);

export default PaymentProgress;
